<template>
  <div style="margin-top: 86px">
    <div class="aboutus">
      <div class="aboutus-top">U-vigor Health</div>
      <div>
        <el-row :gutter="30" style="padding-top:100px; margin: 150px 100px">
          <el-col :span="10">
            <el-image
              style="height: 500px"
              :src="require('../../assets/image/contact/us_building.jpg')"
              fit="contain"></el-image>
          </el-col>
          <el-col :span="14" style="background-color: #e2e2e2">
            <div class="aboutus-below">Advanced Medical Devices and Integrated Solutions</div>
            <div class="aboutus-content">U-vigor Health has accumulated More than 10 years experiences in medical and diagnostic field.
              We are providing animal medical solutions including medical imaging system, rapid tests, patient monitors, surgical equipment and cages.
              Innovation, quality and service are our core values.
            </div>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-row :gutter="30" style="margin: 150px 100px">
          <el-col :span="14">
            <div class="aboutus-buttom-title">Medical Imaging Solutions for all animals</div>
            <div class="aboutus-buttom-item">
              Quality
            </div>
            <div class="aboutus-buttom-content">
              Quality is always the top priority. All quality related issues shall be 100% covered.
            </div>
            <div class="aboutus-buttom-item">
              Service
            </div>
            <div class="aboutus-buttom-content">
              U-vigor health provides product training, efficient transportation and comprehensive after-sale service.
            </div>
            <div class="aboutus-buttom-item">
              Innovation
            </div>
            <div class="aboutus-buttom-content">
              We are trying best to make products user-friendly based on technology and information system.
            </div>
          </el-col>
          <el-col :span="10">
            <el-image
              style="height: 500px"
              :src="require('../../assets/image/contact/us_solution.jpg')"
              fit="contain"></el-image>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'AboutUs',
  data() {
    return {

    }
  }
}
</script>

<style src="../../assets/css/aboutus.css" scoped>
</style>
